
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPropulsionMainEngine as ObiPropulsionMainEngineElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-propulsion-main-engine.js';
 
 
 

 
 export const ObiPropulsionMainEngine = createComponent({
   react: React,
   tagName: 'obi-propulsion-main-engine',
   elementClass: ObiPropulsionMainEngineElement,
   events: {
     
   }
  });
 
 